module.exports = __webpack_public_path__ + "static/media/015-Aktivierung_ID_38.be76b80c.mp3";